import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-common-error',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './common-error.component.html',
  styleUrls: ['./common-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonErrorComponent {
  route = inject(ActivatedRoute);
  translate = inject(TranslateService);

  paramMap = toSignal(this.route.paramMap);

  errorInfo = computed(() => {
    const code = this.paramMap()?.get('code') || '500';
    switch (code) {
      case '401':
      case '403':
        return {
          icon: 'images/user-account-info.svg',
          altKey: 'ERROR.401.TITLE',
          titleKey: 'ERROR.401.TITLE',
          descriptionKey: 'ERROR.401.DESCRIPTION',
        };
      case '500':
      default:
        return {
          icon: 'images/service-unavailable.svg',
          altKey: 'ERROR.500.TITLE',
          titleKey: 'ERROR.500.TITLE',
          descriptionKey: 'ERROR.500.DESCRIPTION',
          description2PreLinkKey: 'ERROR.500.DESCRIPTION2',
        };
    }
  });
}
